/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('../bootstrap');
require('../plugins');
require('./mapHandler.js');



require('leaflet/dist/leaflet.js');
require('leaflet.locatecontrol/dist/L.Control.Locate.min');

import {Html5Qrcode} from "html5-qrcode";
window.Html5Qrcode = Html5Qrcode;

import icon from 'leaflet/dist/images/marker-icon.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    iconRetinaUrl: iconRetina,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 39]
});
// Corregge le icone di default.
L.Marker.prototype.options.icon = DefaultIcon;

